//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CourseContentDto } from '../../coursecontents/dto/CourseContentDto';
import { IApiRequest } from '../../IApiRequest';

export class GetCourseContentRequest extends IApiRequest<CourseContentDto>
{
	public $type = 'GetCourseContentRequest';
	constructor(public data: { courseDomainId: string, lang?: string }) { super(); }
}
